import { Box } from "@mui/material";
import { Heat } from "graphql/generated/types";

interface Styles {
    aspectRatio: number;
    width?: number | string;
    maxWidth?: string;
    height?: number | string;
    maxHeight?: string;
}

interface Props {
    width: Heat["media"][number]["width"];
    height: Heat["media"][number]["height"];
    fluid?: boolean;
}

export const MediaSkeleton: React.FC<Props> = ({
    width: w,
    height: h,
    fluid,
}) => {
    const width = w || 400;
    const height = h || 400;

    const orientation = width > height ? "landscape" : "portrait";

    const styles: Styles = {
        aspectRatio: width / height,
    };

    if (orientation === "landscape") {
        styles.width = width;
        styles.maxWidth = "100%";
    } else {
        styles.height = height;
        styles.maxHeight = "100%";
    }

    if (fluid) {
        styles.width = "100%";
        styles.height = "100%";
    }

    return (
        <Box
            role="status"
            aria-label="loading"
            className="skeleton"
            width="100%"
            height="100%"
        >
            <Box className="fake" sx={styles} />
        </Box>
    );
};
